import { fmtP } from "@/lib/jackpot";
import { ShareWin } from "@/components/ShareWin";

const COPY = {
  plus: { t: "+1.000!", s: "Du hast den Lotto-Jackpot wachsen lassen.", c: "text-pink-300" },
  minus: { t: "−1.000", s: "Autsch – der Jackpot ist etwas geschrumpft. Nächster Dreh?", c: "text-white/80" },
  double: { t: "VERDOPPELT!", s: "Unglaublich – du hast den Jackpot verdoppelt!", c: "jr-gold-text" },
  halve: { t: "HALBIERT!", s: "Oh nein – der Jackpot wurde halbiert. Dreh weiter und hol die Punkte zurück!", c: "text-slate-200" },
  bankrupt: { t: "BANKROTT!", s: "Der Jackpot ist weg – für diese Woche ist das Event beendet und niemand gewinnt.", c: "text-red-500" },
};

export function SpinResult({ spin, onClose }) {
  const c = COPY[spin.result];
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center p-4 bg-black/70 backdrop-blur-md wheel-fade" data-testid="jr-result-modal" onClick={onClose}>
      <div className={`relative w-full max-w-sm rounded-[2rem] jr-panel jr-pop p-7 text-center ${spin.result === "bankrupt" ? "jr-shake" : ""}`} onClick={(e) => e.stopPropagation()}>
        <p className="text-[11px] font-extrabold uppercase tracking-[0.3em] text-amber-300/80">Dein Dreh</p>
        {spin.close && <p className="mt-2 inline-block px-3 py-1 rounded-full bg-red-600/25 ring-1 ring-red-400/50 text-xs font-extrabold text-red-200" data-testid="jr-result-close-call">Puh – ganz knapp am BANKROTT vorbei!</p>}
        <p className={`font-display text-4xl sm:text-5xl font-black mt-2 ${c.c}`} data-testid="jr-result-title">{c.t}</p>
        <p className="mt-2 text-sm text-white/75">{c.s}</p>
        <div className="mt-5 flex items-center justify-center gap-3 text-white" data-testid="jr-result-amounts">
          <span className="text-white/50 line-through tabular-nums">{fmtP(spin.before)}</span>
          <span className="text-amber-300">→</span>
          <span className="font-display text-2xl font-extrabold jr-gold-text tabular-nums">{fmtP(spin.after)}</span>
        </div>
        {spin.result === "double" && <div className="mt-4"><ShareWin dark testId="jr-share" text={`Ich habe gerade den itzPlay Lotto-Jackpot auf ${fmtP(spin.after)} Punkte verdoppelt! 💎 Dreh mit beim JACKPOT ROULETTE`} /></div>}
        <button onClick={onClose} data-testid="jr-result-close" className="mt-6 w-full h-12 rounded-full bg-white text-[#12040d] font-extrabold active:scale-[0.98] transition-transform">Weiter</button>
      </div>
    </div>
  );
}
